import { useEffect, useMemo, } from 'react';
import { db, } from '../firebase/config';
import { collection, query, where, orderBy, limit, onSnapshot, } from 'firebase/firestore';
import { useSetState, useMountedState, } from 'react-use';
import { useIsEqualPrev, } from './useIsEqualPrev';

export const useCollection = ({ col, _query, _orderBy, _limit, }) => {
    const [state, setState] = useSetState({
        documents: null,
        isPending: false,
        error: null,
    });

    const isMounted = useMountedState();

    const isEqualQueries = useIsEqualPrev(_query);
    const isEqualOrders = useIsEqualPrev(_orderBy);

    const q = useMemo(() => _query, [isEqualQueries]);
    const order = useMemo(() => _orderBy, [isEqualOrders]);

    useEffect(() => {
        setState({
            documents: null,
            isPending: true,
            error: null,
        });

        let ref = collection(db, col);

        if (q) {
            q.forEach((item, index) => ref = query(ref, where(...q[index])));
        }

        if (order) {
            ref = query(ref, orderBy(...order));
        }

        if (_limit) {
            ref = query(ref, limit(_limit));
        }

        const unsubscribe = onSnapshot(ref, (snapshot) => {
            let results = [];

            snapshot.docs.forEach((doc) => {
                results.push({
                    ...doc.data(),
                    id: doc.id,
                });
            });

            if (isMounted()) {
                setState({
                    documents: results,
                    isPending: false,
                    error: null,
                });
            }
        }, (error) => {
            if (isMounted()) {
                setState({
                    documents: null,
                    isPending: false,
                    error,
                });
            }
        });

        return () => unsubscribe();

    }, [col, q, order, _limit]);

    return state;
};